var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import apiRequest from '../utils/apiRequest';
import { useHistory } from 'react-router-dom';
function useApi() {
    var push = useHistory().push;
    var _a = __read(useState(), 2), error = _a[0], setError = _a[1];
    var _b = __read(useState(null), 2), success = _b[0], setSuccess = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    function get(url) {
        return __awaiter(this, void 0, void 0, function () {
            var request, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setSuccess(null);
                        setLoading(true);
                        setError(null);
                        return [4 /*yield*/, apiRequest(url)];
                    case 1:
                        request = _a.sent();
                        setLoading(false);
                        if (request.error) {
                            if (request.error === 'TOKEN_IS_MISSING') {
                                push('/login');
                            }
                            setError(request.error);
                        }
                        else if (request.success) {
                            setSuccess(true);
                        }
                        return [2 /*return*/, request];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        setLoading(false);
                        setError('ERROR_GETTING_API');
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function remove(url) {
        return __awaiter(this, void 0, void 0, function () {
            var request, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setSuccess(null);
                        setLoading(true);
                        setError(null);
                        return [4 /*yield*/, apiRequest(url, {
                                method: 'delete',
                            })];
                    case 1:
                        request = _a.sent();
                        setLoading(false);
                        if (request.error) {
                            if (request.error === 'TOKEN_IS_MISSING') {
                                push('/login');
                            }
                            setError(request.error);
                        }
                        else if (request.success) {
                            setSuccess(true);
                        }
                        return [2 /*return*/, request];
                    case 2:
                        err_2 = _a.sent();
                        setLoading(false);
                        setError('ERROR_DELETING_API');
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function post(url, data) {
        return __awaiter(this, void 0, void 0, function () {
            var request, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setSuccess(null);
                        setLoading(true);
                        setError(null);
                        return [4 /*yield*/, apiRequest(url, {
                                body: data,
                                method: 'POST',
                            })];
                    case 1:
                        request = _a.sent();
                        setLoading(false);
                        if (request.error) {
                            if (request.error === 'TOKEN_IS_MISSING') {
                                push('/login');
                            }
                            setError(request.error);
                        }
                        else {
                            setSuccess(true);
                        }
                        return [2 /*return*/, request];
                    case 2:
                        err_3 = _a.sent();
                        setLoading(false);
                        setError('ERROR_POSTING_API');
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function postFile(url, data) {
        return __awaiter(this, void 0, void 0, function () {
            var request, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setSuccess(null);
                        setLoading(true);
                        setError(null);
                        return [4 /*yield*/, apiRequest(url, {
                                file: data,
                                method: 'POST',
                                contentType: '',
                            })];
                    case 1:
                        request = _a.sent();
                        setLoading(false);
                        if (request.error) {
                            if (request.error === 'TOKEN_IS_MISSING') {
                                push('/login');
                            }
                            setError(request.error);
                        }
                        else {
                            setSuccess(true);
                        }
                        return [2 /*return*/, request];
                    case 2:
                        err_4 = _a.sent();
                        setLoading(false);
                        setError('ERROR_POSTING_API');
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function put(url, data) {
        return __awaiter(this, void 0, void 0, function () {
            var request, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        setSuccess(null);
                        setLoading(true);
                        setError(null);
                        return [4 /*yield*/, apiRequest(url, {
                                body: data,
                                method: 'put',
                            })];
                    case 1:
                        request = _a.sent();
                        setLoading(false);
                        if (request.error) {
                            if (request.error === 'TOKEN_IS_MISSING') {
                                push('/login');
                            }
                            setError(request.error);
                        }
                        else if (request.success) {
                            setSuccess(true);
                        }
                        return [2 /*return*/, request];
                    case 2:
                        err_5 = _a.sent();
                        setLoading(false);
                        setError('ERROR_POSTING_API');
                        return [2 /*return*/];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return {
        error: error,
        loading: loading,
        success: success,
        post: post,
        get: get,
        put: put,
        remove: remove,
        postFile: postFile,
    };
}
export default useApi;
